import { IKnmStatusSelectOption } from 'CorePackage/CatalogsModule/interfaces/IKnmStatusSelectOption';
import { KnmErknmStatusCodesEnum } from 'APIPackage/CatalogsModule/enums/KnmErknmStatusCodesEnum';

import { PublishRulesCategoriesEnum } from '../enums/publishRulesCategoriesEnum';
import { IPublishRulesKnmScheduledForm } from '../interfaces/IPublishRulesKnmScheduledForm';
import { IPublishRulesTreeItem } from '../interfaces/IPublishRulesTreeItem';

export const getPublishRulesKnmScheduledFormInitialValues: (
  treeItem: IPublishRulesTreeItem,
  knmStatusesSelectOptions?: IKnmStatusSelectOption[],
) => IPublishRulesKnmScheduledForm = (treeItem, knmStatusesSelectOptions) => {
  const completedKnmStatusOption = knmStatusesSelectOptions?.find(
    item => item.value === KnmErknmStatusCodesEnum.TYPE_COMPLETED,
  );

  const waitingCarryOutKnmStatusOption = knmStatusesSelectOptions?.find(
    item => item.value === KnmErknmStatusCodesEnum.TYPE_WAITING_CARRY_OUT,
  );

  const cantBeCarryOutKnmStatusOption = knmStatusesSelectOptions?.find(
    item => item.value === KnmErknmStatusCodesEnum.TYPE_CANT_BE_CARRY_OUT,
  );

  switch (treeItem.category) {
    case PublishRulesCategoriesEnum.PLANNED_KNM:
      return {
        uponAttainingStatus: waitingCarryOutKnmStatusOption ? [waitingCarryOutKnmStatusOption] : undefined,
        publicationDate: '15.12',
        additionalSettings: [],
      };
    case PublishRulesCategoriesEnum.PLANNED_KNM_KZ:
    case PublishRulesCategoriesEnum.PLANNED_KNM_RO:
    case PublishRulesCategoriesEnum.PLANNED_KNM_VK:
    case PublishRulesCategoriesEnum.PLANNED_KNM_IV:
    case PublishRulesCategoriesEnum.PLANNED_KNM_MZ:
      return {
        uponAttainingStatus:
          completedKnmStatusOption && cantBeCarryOutKnmStatusOption
            ? [completedKnmStatusOption, cantBeCarryOutKnmStatusOption]
            : undefined,
        publicationDate: '15.12',
        additionalSettings: [],
      };
    case PublishRulesCategoriesEnum.PLANNED_KNM_DP:
    case PublishRulesCategoriesEnum.PLANNED_KNM_VP:
      return {
        uponAttainingStatus: waitingCarryOutKnmStatusOption ? [waitingCarryOutKnmStatusOption] : undefined,
        publicationDate: '20.12',
        additionalSettings: [],
      };
    default:
      return { uponAttainingStatus: undefined, publicationDate: undefined, additionalSettings: [] };
  }
};
